import { render, staticRenderFns } from "./customCheckBox.vue?vue&type=template&id=bf51862e&scoped=true"
import script from "./customCheckBox.vue?vue&type=script&lang=js"
export * from "./customCheckBox.vue?vue&type=script&lang=js"
import style0 from "./customCheckBox.vue?vue&type=style&index=0&id=bf51862e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf51862e",
  null
  
)

export default component.exports